import React from "react";
import { Flex, Divider } from "@fluentui/react-northstar";

import { Devices } from "../../../types/Device.types";
import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

import { ResultsDeviceStatusCard } from "./ResultsDeviceStatusCard";
import { useResultsDeviceStatusCardStyles } from "./ResultsDeviceStatusCard.styles";

// Results page for desktop and mobile devices
export const ConnectedResultsDeviceStatusCard: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const deviceStatusCardStyles = useResultsDeviceStatusCardStyles();
  const { isMobile } = usePlatformTypeContext();

  // return Status cards for Network, Camera, Mic, and Speaker devices
  return (
    <Flex styles={deviceStatusCardStyles.deviceResultContainer} column>
      <ResultsDeviceStatusCard
        device-testid="networkDialog"
        testResult={deviceTesterState.networkResult}
        deviceName={Devices.Network}
        isMobile={isMobile}
        selectedDevice={deviceTesterState.deviceSettings.selectedCamera}
      />
      <Divider />
      <ResultsDeviceStatusCard
        device-testid="cameraDialog"
        testResult={deviceTesterState.cameraResult}
        deviceName={Devices.Camera}
        isMobile={isMobile}
        selectedDevice={deviceTesterState.deviceSettings.selectedCamera}
      />
      <Divider />
      <ResultsDeviceStatusCard
        device-testid="micDialog"
        testResult={deviceTesterState.microphoneResult}
        deviceName={Devices.Mic}
        isMobile={isMobile}
        selectedDevice={deviceTesterState.deviceSettings.selectedMicrophone}
      />
      <Divider />
      <ResultsDeviceStatusCard
        device-testid="speakerDialog"
        testResult={deviceTesterState.speakerResult}
        deviceName={Devices.Speaker}
        isMobile={isMobile}
        selectedDevice={deviceTesterState.deviceSettings.selectedSpeaker}
      />
      <Divider />
    </Flex>
  );
};
